/*
 * Defining constants with dates
 */

/* Thu, 01 Jan 1970 00:00:00 GMT */
export const MIN_DATE_OF_INCORPORATION: Date = new Date(1970);
export const MIN_PASSPORT_ISSUE_DATE: Date = new Date(1900, 0, 1);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/constants/system.dates.ts